var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf"},[_c('embed',{attrs:{"src":"\n      consent-personal-prof.pdf","type":"application/pdf","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }